import {TranslationKey} from 'common/i18n';
import {CurrentProjectResource} from 'common/report/model-resources/projects';
import {ProjectFeatureFlag} from 'common/report/constants';

import {MetricType, TopLevelMetricTypeFilter} from '../metrics/types';

export const TopLevelMetricTypeFilterI18nKey: Record<TopLevelMetricTypeFilter, TranslationKey> = {
  [TopLevelMetricTypeFilter.All]: `lexicon.metrics.type-filter.all`,
  [TopLevelMetricTypeFilter.Metric]: `lexicon.metrics.type-filter.metric`,
  [TopLevelMetricTypeFilter.Formula]: `lexicon.metrics.type-filter.formula`,
};

export const MetricTypeI18nKey: Record<MetricType, TranslationKey> = {
  [MetricType.Metric]: `lexicon.metrics.type.metric`,
  [MetricType.Formula]: `lexicon.metrics.type.formula`,
  // Shouldn't be used.
  [MetricType.Behavior]: `lexicon.metrics.type.behavior`,
};

export function hasFirstClassMetrics(currentProject: CurrentProjectResource) {
  return currentProject.get()?.value?.hasFeatureFlag(ProjectFeatureFlag.FirstClassMetrics);
}
